module.exports = __webpack_public_path__ + "static/media/InfoCircle.d19d5ec2.svg";